import React, { useState } from "react";
import { ModelForm } from "./components/ModelForm";
import { useToast } from "@chakra-ui/react";
import { Mutation, MutationFn } from "react-apollo";
import {
  createModelMutation,
  CreateModelVariables,
  CreateModelResult,
  MODEL_RESPONSE_PAYLOAD,
  UpdateModelVariables,
  ModelInput,
} from "./queries";
import { RedirectIfNotAuthorized } from "./components/RedirectIfNotAuthorized";
import { RouteComponentProps } from "react-router";

const PAYLOAD = MODEL_RESPONSE_PAYLOAD.CREATE;

export const NewModel = (props: RouteComponentProps): JSX.Element => {
  const toast = useToast({ duration: 5000, isClosable: true });
  const [isFormSubmitting, setIsFormSubmitting] = useState(false);

  const enableFormSubmitButton = () => {
    setIsFormSubmitting(false);
  };

  const disableFormSubmitButton = () => {
    setIsFormSubmitting(true);
  };

  const handleFormSubmit =
    (mutation: MutationFn<CreateModelResult, CreateModelVariables>) =>
    async (model: ModelInput) => {
      try {
        disableFormSubmitButton();
        const result = await mutation({
          variables: {
            model,
          },
        });

        if (!result) {
          toast({
            title: "Error",
            description: "An unknown error occurred.",
            status: "error",
          });
          return;
        }

        const message = result.data?.createModel?.message;
        const payload = result.data?.createModel?.payload;

        if (payload !== PAYLOAD.SUCCESS) {
          toast({
            title: "Error",
            description: message,
            status: "error",
          });
          enableFormSubmitButton();
          return;
        }

        toast({
          title: "Success",
          description: message,
          status: "success",
        });

        props.history.push(
          `/models/${result.data?.createModel?.model?.id}/edit`
        );
      } catch (err) {
        console.error(err);
        toast({
          title: "Error",
          description: "An unknown error occurred.",
          status: "error",
        });
        enableFormSubmitButton();
      }
    };
  return (
    <RedirectIfNotAuthorized>
      <Mutation<CreateModelResult, UpdateModelVariables>
        mutation={createModelMutation}
      >
        {(mutation) => {
          return (
            <ModelForm
              title="New Model"
              onSubmit={handleFormSubmit(mutation)}
              isFormSubmitting={isFormSubmitting}
              buttonText="Create Model"
              buttonLoadingText="Creating Model"
            />
          );
        }}
      </Mutation>
    </RedirectIfNotAuthorized>
  );
};
